export default [
  { label: 'Publiczne', value: 'PUBLIC' },
  { label: 'Niepubliczne', value: 'NON_PUBLIC' },
]
